import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { useMe } from '@/hooks/useMe';
import { CheckWavesSolid } from '@mynaui/icons-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export default function EmailVerifiedPage() {
  const navigate = useNavigate();
  const { me } = useMe();
  const { t } = useTranslation('auth');

  return (
    <div className='bg-slate-50 flex min-h-svh flex-col items-center justify-center p-6 md:p-10'>
      <div className='w-full max-w-sm md:max-w-md'>
        <Card className='overflow-hidden p-0'>
          <CardContent className='p-6 md:p-8'>
            <div className='flex flex-col items-center text-center gap-6'>
              <div className='flex flex-col items-center'>
                <div className='size-20 bg-emerald-50 rounded-full flex items-center justify-center'>
                  <CheckWavesSolid className='size-12 text-emerald-600' />
                </div>
                <h1 className='font-semibold mt-4 text-emerald-600'>{t('emailVerification.emailVerified')}</h1>
                <p className='text-sm text-slate-500 mt-1'>{t('emailVerification.emailVerifiedDescription')}</p>
                <Button
                  variant='ghost'
                  onClick={() => navigate(me?.email ? '/' : '/auth/login')}
                  className='mt-4'
                >
                  {me?.email ? t('emailVerification.backToDashboard') : t('emailVerification.backToLogin')}
                </Button>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
